const ArrayOrderSort = (a, b) => {
    return a.order - b.order;
}

export default ArrayOrderSort;